import getDisplayName from './get-display-name';

export default function createHocName(
  hocComponentName: string,
  WrappedComponent: { displayName?: string; name?: string },
) {
  return `${hocComponentName}(${getDisplayName(WrappedComponent)})`;
}
